
import { Link, useLocation } from 'react-router-dom';
import { useState } from 'react';

export default function Header() {
  const location = useLocation();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  const navItems = [
    { path: '/presentacion', label: 'Inicio', icon: 'ri-home-line' },
    { path: '/modulos', label: 'Módulos', icon: 'ri-book-line' },
    { path: '/precios', label: 'Precios', icon: 'ri-price-tag-3-line' },
    { path: '/pago', label: 'Pago', icon: 'ri-secure-payment-line' }
  ];

  const isActive = (path: string) => location.pathname === path;

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  };

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  };

  return (
    <header className="bg-white shadow-sm border-b sticky top-0 z-50">
      <div className="container mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo */}
          <Link to="/presentacion" className="flex items-center space-x-3 cursor-pointer" onClick={closeMobileMenu}>
            <img 
              src="https://static.readdy.ai/image/c9dd91c630c89e34554970cc86118743/c21e21ece24cfd7a637296305c96022e.jfif" 
              alt="INDEFINHUM Logo" 
              className="h-8 w-8 sm:h-10 sm:w-10 object-contain rounded-lg"
            />
            <div className="hidden sm:block">
              <h1 className="text-lg sm:text-xl font-bold bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 bg-clip-text text-transparent">INDEFINHUM CURSO IA</h1>
              <p className="text-xs text-gray-500">Educación del Futuro</p>
            </div>
            <div className="block sm:hidden">
              <h1 className="text-sm font-bold bg-gradient-to-r from-yellow-400 via-orange-500 to-red-500 bg-clip-text text-transparent">INDEFINHUM</h1>
            </div>
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg transition-all duration-300 cursor-pointer whitespace-nowrap ${
                  isActive(item.path)
                    ? 'bg-blue-100 text-blue-600 font-semibold'
                    : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                }`}
              >
                <i className={`${item.icon} text-lg`}></i>
                <span>{item.label}</span>
              </Link>
            ))}
          </nav>

          {/* Desktop CTA Button */}
          <div className="hidden md:block">
            <Link 
              to="/precios" 
              className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-lg font-semibold hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap"
            >
              Comenzar Ahora
            </Link>
          </div>

          {/* Mobile Menu Button */}
          <button 
            onClick={toggleMobileMenu}
            className="md:hidden w-10 h-10 flex items-center justify-center text-gray-600 hover:text-blue-600 cursor-pointer transition-colors duration-300"
          >
            <i className={`${isMobileMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-xl transition-transform duration-300`}></i>
          </button>
        </div>

        {/* Mobile Navigation */}
        <div className={`md:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}>
          <div className="border-t py-4">
            <nav className="flex flex-col space-y-2">
              {navItems.map((item) => (
                <Link
                  key={item.path}
                  to={item.path}
                  onClick={closeMobileMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg transition-all duration-300 cursor-pointer transform hover:scale-105 ${
                    isActive(item.path)
                      ? 'bg-blue-100 text-blue-600 font-semibold shadow-md'
                      : 'text-gray-600 hover:text-blue-600 hover:bg-blue-50'
                  }`}
                >
                  <i className={`${item.icon} text-lg`}></i>
                  <span className="font-medium">{item.label}</span>
                </Link>
              ))}
              <Link 
                to="/precios" 
                onClick={closeMobileMenu}
                className="bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-3 rounded-lg font-semibold hover:shadow-lg transition-all duration-300 cursor-pointer whitespace-nowrap text-center mt-4 transform hover:scale-105"
              >
                <i className="ri-rocket-line mr-2"></i>
                Comenzar Ahora
              </Link>
            </nav>
          </div>
        </div>
      </div>

      {/* Mobile Menu Overlay */}
      {isMobileMenuOpen && (
        <div 
          className="md:hidden fixed inset-0 bg-black/20 z-30 transition-opacity duration-300"
          onClick={closeMobileMenu}
        ></div>
      )}
    </header>
  );
}
